import 'Application/Templates/Css/Layer/Chat.css'
import { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

export const Live = (props) => {
    const [isAvailable, setAvailability] = useState(false)
    const dispatch = useDispatch()
    const iframeRef = useRef(null)
    const minimized = useSelector(state => state.LayoutReducer?.live?.minimized)
    const isMobile = useSelector(state => {
        const g = state.LayoutReducer?.global
        return g ? (g.isPortrait || g.isMobileLandscape) : false
    })

    useEffect(() => {
        if (typeof window !== 'undefined' && 'Notification' in window) {
            if (Notification.permission === 'default') {
                Notification.requestPermission();
            }
        }

        fetch(process.env.REACT_APP_U1_VIEWERSVC_LIVE + "?caseId=" + props.caseId).then(
            response => {
                if (response.status === 200) {
                    setAvailability(true)
                } else {
                    dispatch({ type: "USER_DISCONNECTED", payload: true })
                    setAvailability(false)
                }
            })

        const handleMessage = (event) => {
            if (event.data === 'CLOSE_LIVE') {
                dispatch({ type: 'CLOSE_LIVE', payload: null })
            } else if (event.data && event.data.type === 'NEW_CHAT_MESSAGE') {
               }
        }
        window.addEventListener('message', handleMessage)
        return () => window.removeEventListener("message", handleMessage)
    }, [props.type, dispatch, props.caseId, minimized, isMobile])

    if (!isAvailable) return null

    const isMinimized = isMobile ? false : minimized
    const tab = props.tab || 'chat'
    const src = process.env.REACT_APP_U1_VIEWERSVC_LIVE
        + "?caseId=" + props.caseId
        + `&tab=${encodeURIComponent(tab)}`
        + `&chat=${tab !== 'files'}`
        + `&dz=${tab === 'files'}`

    const iframeEl = (
        <iframe
            ref={iframeRef}
            title='liveIframe'
            allowTransparency="true"
            style={{background: 'transparent'}}
            src={src}
            id="liveIframe"
        />
    )

    return (
        <aside id='chatBox' className={isMinimized ? 'live-minimized' : ''}>
            {!isMinimized && (
                <div
                    id="liveBackdrop"
                    onClick={() => dispatch({ type: 'CLOSE_LIVE', payload: null })}
                />
            )}
            {isMinimized ? (
                <div id="liveMini" className="glass-panel">
                    <button
                        type="button"
                        id="liveMiniMaxBtn"
                        onClick={() => dispatch({ type: 'LIVE_MINIMIZE', payload: !isMinimized })}
                        aria-label="Agrandir"
                        title="Agrandir"
                    >
                        □
                    </button>
                    <button
                        type="button"
                        id="liveMiniCloseBtn"
                        onClick={() => dispatch({ type: 'CLOSE_LIVE', payload: null })}
                        aria-label="Fermer"
                        title="Fermer"
                    >
                        ×
                    </button>
                    {iframeEl}
                </div>
            ) : (
                <div id="liveModal" className="glass-panel">
                    <button
                        type="button"
                        id="liveMinimizeBtn"
                        onClick={() => dispatch({ type: 'LIVE_MINIMIZE', payload: !isMinimized })}
                        aria-label="Réduire"
                        title="Réduire"
                    >
                        _
                    </button>
                    <button
                        type="button"
                        id="liveCloseBtn"
                        onClick={() => dispatch({ type: 'CLOSE_LIVE', payload: null })}
                        aria-label="Fermer"
                        title="Fermer"
                    >
                        ×
                    </button>
                    {iframeEl}
                </div>
            )}
        </aside>
    )
}
